import Image from 'next/legacy/image';
import loadingbox from 'public/static/images/srp/Loading_Image.svg';
import styles, { imageStyles } from './styles';

export default function SrpLoadingCard(): JSX.Element {
  return (
    <div className="search-result" data-testid="search-result">
      <div className="images-container">
        <Image
          objectFit="cover"
          src={loadingbox}
          key={loadingbox}
          alt="loading image"
          width={817}
          height={487}
          style={imageStyles}
          className="image-container"
        />
      </div>
      <div className="placeholder-details">
        <div className="placeholder-left">
          <div className="bar xl" />
          <div className="bar l" />
          <div className="bar xl" />
          <div className="bar xl last" />
        </div>
        <div className="placeholder-middle">
          <div className="bar xl" />
          <div className="bar m" />
          <div className="bar xl" />
        </div>
        <div className="placeholder-right">
          <div className="bar xs" />
          <div className="bar s" />
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
